





















import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AsiCardDetail from "./common/AsiCardDetail.vue";
import IBlamable from "../models/IBlamable";
import {Icon} from "@/helpers/icons";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import UserBlamable from "@/models/user/UserBlamable";

@Component({
	components: {AsiCardDetailEntry, AsiCardDetail}
})
export default class CardBlamable extends Vue {

	@Prop({type: Object, required: true})
	public model!: IBlamable;

	private icons = Icon;

	private fullName(user: UserBlamable): string | null {
		return UserBlamable.fullName(user);
	}

	private formatDateTime(value: string | null): string | null {
		if (value === null) return null;
		return this.$d(new Date(value), 'long').toString();
	}

}
